
export const NEW_PASSWORD_REQUIRED = 'NewPasswordRequiredException'
export const USER_NOT_FOUND = 'UserNotFoundException'
export const INVALID_PASSWORD = 'InvalidPasswordException'
export const BAD_DATA = 'BadData'
export const SQL_ACLHEMY_ERROR = 'SQLAlchemyError'
export const MAX_RETRIES = 'MaxRetriesException'
export const SOFTWARE_TOKEN_MFA_REQUIRED = 'SoftwareTokenMfaException'
export const MFA_ENROLLMENT_REQUIRED = 'MfaEnrollmentRequiredException'
export const CODE_MISMATCH = 'CodeMismatchException'
export const ENABLE_SOFTWARE_TOKEN_MFA = 'EnableSoftwareTokenMFAException'
export const EXPIRED_CODE = 'ExpiredCodeException'
export const NOT_AUTHORIZED = 'NotAuthorizedException'
export const MFA_CHALLENGE_EXPIRED = 'MfaChallengeExpiredException'
export const TOO_MANY_REQUESTS = 'TooManyRequestsException'
export const LIMIT_EXCEEDED = 'LimitExceededException'
// export const BAD_CREDENTIALS = 'BadCredentialsException'
